import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getBanners = () =>
  fetch(
    `${API_BASE_URL}/banners`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  .then(res => res.json())


export const saveBanner = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/banners`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editBanner = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/banners/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deleteBanner = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/banners/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  return await res.json()
}